import axios from "axios";
import { setToast } from "../../../util/toast";

export const sendNotificationToUser = (payload) => (dispatch) => {
  return axios
    .post("admin/notification/sendToUser", payload)
    .then((res) => {
      if (res.data.status) {
        setToast(
          "success",
          res.data.message || "Notification sent to user successfully!"
        );
      } else {
        setToast("error", res.data.message || "Failed to send notification");
      }
      return res;
    })
    .catch((error) => {
      setToast(
        "error",
        error?.response?.data?.message ||
          error?.message ||
          "Failed to send notification"
      );
      throw error;
    });
};

export const sendNotificationToAllUsers = (payload) => (dispatch) => {
  return axios
    .post("admin/notification/sendToAllUsers", payload)
    .then((res) => {
      if (res.data.status) {
        setToast(
          "success",
          res.data.message || "Notification sent to all users successfully!"
        );
      } else {
        setToast("error", res.data.message || "Failed to send notification");
      }
      return res;
    })
    .catch((error) => {
      setToast(
        "error",
        error?.response?.data?.message ||
          error?.message ||
          "Failed to send notification"
      );
      throw error;
    });
};
